// extracted by mini-css-extract-plugin
export default {"xs":"0","sm":"576","md":"768","lg":"892","xl":"1200","dashboard":"Dashboard_dashboard__sX70D","app":"Dashboard_app__RaM27","container":"Dashboard_container__vcBR8"};